import { REGISTER } from "../actionTypes";

const register = (id, ref, code) => {
  return {
    type: REGISTER,
    id,
    ref,
  };
};

export { register };